"use client";

import React from "react";
import EditSection, { TextEditor, ListItemEditor } from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function AIFeaturesEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const handleChange = (updated: Record<string, any>) => {
    onContentChange?.(updated);
  };

  const defaultFeatures = [
    { title: "Neural Networks", description: "Deep learning models tailored for specific industry datasets.", icon: "brain" },
    { title: "Autonomous Agents", description: "Intelligent workflows that plan and solve complex tasks.", icon: "network" },
    { title: "Scale Infrastructure", description: "High-performance nodes hosting custom weight arrays.", icon: "cube" }
  ];

  return (
    <EditSection
      content={content}
      onContentChange={handleChange}
      contentFields={
        <div className="space-y-4">
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Section Headers</h4>
            <TextEditor
              label="Title"
              value={content.title}
              onChange={(v) => handleChange({ ...content, title: v })}
              placeholder="Engineered for Intelligence"
            />
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Features List</h4>
            <ListItemEditor
              label="Features"
              items={content.features || defaultFeatures}
              itemSchema={[
                { key: "title", label: "Feature Title", type: "text" },
                { key: "description", label: "Description", type: "text" },
                { key: "icon", label: "Icon Name (brain, network, cube)", type: "text" },
              ]}
              onChange={(items) => handleChange({ ...content, features: items })}
              addItemText="Add Feature"
            />
          </div>
        </div>
      }
    />
  );
}
